
import { useState } from "react";
//import { ArrowRight, ExternalLink, ChevronRight } from "lucide-react";
import kLogo from "./assets/k_logo_final.png";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TeamPage from "./TeamPage"; // we'll create this next
import SolutionsPage from "./SolutionsPage";
import TestimonialsPage from "./TestimonialsPage";
import Navbar from "./components/Navbar";



// ---- Image imports for the new long cards ----
// Place real photos in: src/assets/cards/
import img12 from "./assets/cards/strategy.png";
import img1 from "./assets/cards/teampicture.jpg";
import img2 from "./assets/cards/mapping.jpg";
import img3 from "./assets/cards/teampicture.jpg";
import img4 from "./assets/cards/branding.png";
import img5 from "./assets/cards/social.jpg";
import img6 from "./assets/cards/ops.png";
import img7 from "./assets/cards/results.png";
import img8 from "./assets/cards/technology.jpg";
import contactSide from "./assets/contactpic.png";
import teamImg from "./assets/teampicture.jpg";
import officepic from "./assets/officepic.png";
import insight1 from "./assets/insights/insight1.jpg";
import insight2 from "./assets/insights/insight2.jpg";
import insight3 from "./assets/insights/insight3.jpg";
import insight4 from "./assets/insights/insight4.jpg";
import insight5 from "./assets/insights/exitpolls.png";



import {
  ArrowRight, ExternalLink, ChevronRight,
  Mail, Briefcase, Building2, Newspaper, Users, DollarSign, MapPin, Phone, Globe
} from "lucide-react";


export default function App() {
  return (
    <Router>
      <Routes>
        {/* HOME PAGE */}
        <Route path="/" element={<HomePage />} />

        {/* TEAM PAGE */}
        <Route path="/team" element={<TeamPage />} />
         <Route path="/solutions" element={<SolutionsPage />} /> 
         <Route path="/testimonials" element={<TestimonialsPage />} />

      </Routes>
    </Router>
  );
}


function HomePage() {
  return (
    <div className="min-h-screen bg-[#0B0A17] text-white font-sans">
      
      <Navbar />
   
      <Hero />
      <StatBar />
      <ImageShowcase />
      <InsightsGrid />
      <FullCircleSection />
      <BigCTA />
      <PhilosophySection />
      <ContactSection />
      <Footer />
    </div>
  );
}


/* ---------------- NAV ---------------- */
function Nav() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/20 backdrop-blur-md">
      <div className="w-full px-6 md:px-12 lg:px-20 py-4 flex items-center justify-between">
        {/* Logo + Brand */}
        <a href="#top" className="flex items-center gap-3 group">
          <img
            src={kLogo}
            alt="Kurukshetra Analytics"
            className="h-8 w-auto transition duration-300 group-hover:scale-110"
          />
          <span className="font-semibold tracking-wide text-white">
            Kurukshetra Analytics
          </span>
        </a>

        {/* Nav Links */}
        <nav className="hidden md:flex items-center gap-8 text-sm text-white/80">
          <a className="hover:text-white transition" href="#showcase">What we do</a>
          
          <a className="hover:text-white transition" href="#insights">Insights</a>
          <a className="hover:text-white transition" href="/solutions">Our Solutions</a>
          <a className="hover:text-white transition" href="/team">Our Team</a> 
          <a className="hover:text-white transition" href="/testimonials">Testimonials</a>
          <a className="hover:text-white transition" href="#getintouch">Contact Us</a>
        </nav>

        {/* Contact Button */}
        <a
  href="https://wa.me/919951186186" // replace with your real number (no '+' sign, no spaces)
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center gap-2 rounded-2xl px-4 py-2 text-white hover:opacity-90"
  style={{fontSize: "14px"}}
  
>
  📞 Call / WhatsApp: <span className="whitespace-nowrap">+91 99511 86186</span>
</a>

      </div>
    </header>
  );
}


/* ---------------- HERO (centered + gentle fade-in) ---------------- */
function Hero() {
  return (
    <section className="relative h-[78vh] sm:h-[86vh] min-h-[460px] sm:min-h-[560px] w-full overflow-hidden flex items-center justify-start text-left">
      {/* Background image */}
      <img
        style={{ paddingTop: "3.5rem" }}
        className="absolute inset-0 h-full w-full object-cover"
        src={officepic}
        alt="Kurukshetra Analytics Background"
      />

      {/* Optional gradient overlay (left emphasis) */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B0A17]/95 via-[#0B0A17]/60 to-transparent" />

      {/* Violet glow */}
      <div
        className="pointer-events-none absolute inset-0 opacity-50"
        style={{
          background:
            "radial-gradient(60% 50% at 40% 50%, rgba(139,92,246,0.35) 0%, rgba(11,10,23,0) 70%)",
          filter: "blur(36px)",
        }}
      />

      {/* LEFT-ALIGNED CONTENT */}
      <div className="relative z-10 max-w-3xl px-6 md:px-12 lg:px-20" style={{maxWidth:"60rem", paddingTop: "6rem"}}>
        <p
          className="fade-up uppercase tracking-widest text-xs text-[#A78BFA]/85"
          style={{ "--d": "50ms" }}
        >
          Political Consulting • India
        </p>

        <h1
          className="fade-up mt-4 font-bold text-white leading-tight"
          style={{
            fontSize: "clamp(2.5rem, 3.5vw + 1rem, 4.75rem)",
            "--d": "200ms",
          }}
        >
          Strategy, Technology &<br />
          Grassroots — United
        </h1>

        <p
          className="fade-up mt-5 text-white/90 text-base md:text-lg leading-relaxed max-w-xl"
          style={{ "--d": "360ms", maxWidth:"60rem" }}
        >
          We bridge leaders and citizens with — data that informs and strategy that delivers.
        </p>

        <div
          className="fade-up mt-8 flex flex-wrap justify-start gap-4"
          style={{ "--d": "500ms" }}
        >
          <a
            href="#getintouch"
            className="group inline-flex items-center gap-2 rounded-2xl px-5 py-3 bg-[#8B5CF6] text-white font-medium hover:brightness-110"
          >
            Schedule a 30-min Consult
            <ChevronRight className="h-5 w-5 transition group-hover:translate-x-0.5" />
          </a>
          <a
            href="#showcase"
            className="inline-flex items-center gap-2 rounded-2xl px-5 py-3 border border-white/35 hover:border-white/60"
          >
            Explore Offerings
          </a>
        </div>
      </div>
    </section>
  );
}


/* ---------------- STATS ---------------- */
function StatBar() {
  const stats = [
    { k: "States", v: "3" },
    { k: "Constituencies mapped", v: "250+" },
    { k: "Booth coverage", v: "95%" },
    { k: "Avg. digital growth (3 mo)", v: "3–5x" },
  ];
  return (
    <section className="w-full px-6 md:px-12 lg:px-20 pb-8" style={{paddingTop:"2rem"}}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((s) => (
          <div key={s.k} className="rounded-2xl border border-white/10 bg-white/5 p-4">
            <div className="text-2xl font-semibold text-[#A78BFA]">{s.v}</div>
            <div className="text-white/75 text-sm">{s.k}</div>
          </div>
        ))}
      </div>
    </section>
  );
}


/* ---------------- IMAGE SHOWCASE (long rectangles, hover zoom + flip on click) ---------------- */
/* ---------------- IMAGE SHOWCASE (portrait cards, hover zoom + flip on click) ---------------- */
function ImageShowcase() {
  const items = [
    {
      img: img1,
      title: "War Room & Strategy",
      caption: "Central command for intel → decisions.",
      back: "Our 24×7 war room synchronizes research, media, and field ops. Rapid message tests, quick pivots, and decisive execution.",
    },
    {
      img: img2,
      title: "Voter Data Mapping",
      caption: "Booth/household intelligence at a glance.",
      back: "Structured voter lists, demographic layers, micro-segments and digital touchpoints feed live dashboards for targeting.",
    },
    {
      img: img3,
      title: "Ground Research",
      caption: "Door-to-door surveys and real voices.",
      back: "Opinion polls, doorstep surveys and qualitative insights uncover local issues and sentiment that actually moves votes.",
    },
    {
      img: img4,
      title: "Branding & Content",
      caption: "Identity that builds trust.",
      back: "Logos, graphics, reels and narrative systems ensure every channel feels coherent, modern, and candidate-true.",
    },
    {
      img: img5,
      title: "Social Media",
      caption: "Town square, daily.",
      back: "Content engines with rapid response, QR growth programs, and sentiment tracking to own the conversation.",
    },
    {
      img: img6,
      title: "Election Day Ops",
      caption: "Agents, logistics, control rooms.",
      back: "Booth-level deployment, turnout control, live reporting and issue resolution—where the plan meets the poll.",
    },
    {
      img: img7,
      title: "Results & Count Oversight",
      caption: "Vigilance till the last vote.",
      back: "Parallel tally verification, exit-trend analysis and risk preparedness ensure transparency and accuracy on counting day.",
    },
    {
      img: img8,
      title: "Technology & Innovation",
      caption: "From data to decisions — instantly.",
      back: "Dashboards, apps and digital tools put actionable intelligence in the hands of leaders and their teams, fast.",
    },
  ];

  return (
    <section id="showcase" className="w-full px-6 md:px-12 lg:px-20 py-12">
      {/* heading as requested */}
      <h2 className="text-3xl font-semibold mb-6">What we do</h2>

      {/* 4 per row on large screens; portrait cards */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {items.map((it, i) => (
          <FlipCard
            key={i}
            image={it.img}
            title={it.title}
            caption={it.caption}
            backText={it.back}
            aspect="3/4" // <-- portrait
          />
        ))}
      </div>
    </section>
  );
}

function FlipCard({ image, title, caption, backText, aspect = "3/4" }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <button
      type="button"
      onClick={() => setFlipped((v) => !v)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setFlipped((v) => !v);
        }
      }}
      className="group relative w-full overflow-hidden rounded-2xl border border-white/10 bg-black/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#8B5CF6]/70"
      style={{ aspectRatio: aspect }} // portrait ratio
    >
      {/* 3D scene */}
      <div className="perspective-1000 h-full w-full">
        <div
          className={`preserve-3d h-full w-full transition-transform duration-500 ${
            flipped ? "rotate-y-180" : ""
          }`}
        >
          {/* FRONT */}
          <div className="absolute inset-0 backface-hidden">
            <img
              src={image}
              alt={title}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.05]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/35 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
             
              <h3 className="text-lg font-semibold">{title}</h3>
              <p className="text-white/80 text-sm mt-1">{caption}</p>
              <p className="text-xs text-white/60 mt-2">Click to flip →</p>
            </div>
          </div>

          {/* BACK */}
          <div className="absolute inset-0 backface-hidden rotate-y-180">
            <div className="h-full w-full rounded-2xl bg-gradient-to-br from-[#1A1630] to-[#0B0A17] border border-white/10 p-6 flex items-center">
              <div>
                
                <h3 className="text-lg font-semibold mb-2">{title}</h3>
                <p className="text-white/80 text-sm leading-relaxed">{backText}</p>
                <p className="text-xs text-white/60 mt-3">Click again to flip back</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
}


/* ---------------- INSIGHTS ---------------- */


function InsightsGrid() {
  const cards = [
      {
      title: "Municipal Elections 2026",
      tag: "EXIT POLL",
      img: insight5,
      link: "https://sites.google.com/view/prajadhwani/home",
    },
    
    {
      title: "The OBC-iasation of Indian Politics and the Telangana Mandate",
      tag: "OPINION",
      img: insight1,
      link: "https://www.linkedin.com/pulse/obc-iasation-indian-politics-telangana-mandate-kurukshetra-analytics-fa5tc/?trackingId=g5A5TyfFSrOKgec4VKzwdw%3D%3D",
    },
    {
      title: "Grassroots Without Voice: How Delayed Local Elections Undermine Democracy",
      tag: "OPINION",
      img: insight2,
      link: "https://www.linkedin.com/pulse/grassroots-without-voice-how-delayed-local-elections-analytics-5tjbc/?trackingId=g5A5TyfFSrOKgec4VKzwdw%3D%3D",
    },
    {
      title: "Land, Cinema, and Power: How Punjabis and Kammas Shaped Bollywood and Tollywood",
      tag: "OPINION",
      img: insight3,
      link: "https://www.linkedin.com/pulse/land-cinema-power-how-punjabis-kammas-shaped-kurukshetra-analytics-nblqc/?trackingId=g5A5TyfFSrOKgec4VKzwdw%3D%3D",
    },
    {
      title: "Digital Census 2027 - From Booths to Bytes",
      tag: "INSIGHT",
      img: insight4,
      link: "https://www.linkedin.com/feed/update/urn:li:activity:7422384140513206272",
    },
  ];

  return (
    <section
      id="insights"
      className="w-full px-6 md:px-12 lg:px-20 py-12 text-center"
    >
      <h2 className="text-3xl font-semibold mb-6">Insights</h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((c, i) => (
          <a
            key={i}
             href={c.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group block rounded-2xl overflow-hidden border border-white/10 bg-black/30 hover:bg-black/40 transition"
          >
            {/* Image container with hover zoom */}
            <div className="relative h-40 overflow-hidden">
              <img
                src={c.img}
                alt={c.title}
                className="absolute inset-0 h-full w-full object-cover transform transition-transform duration-500 group-hover:scale-105"
              />
              {/* Subtle gradient overlay for readability */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
            </div>

            {/* Text content */}
            <div className="p-5 text-left">
              <div className="text-xs uppercase tracking-widest text-[#C4B5FD]">
                {c.tag}
              </div>
              <div className="mt-2 font-semibold leading-snug min-h-[3.5rem]">
                {c.title}
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}



/* ---------------- 360° SERVICES SECTION ---------------- */
function FullCircleSection() {
  return (
    <section
      id="services360"
      className="w-full px-6 md:px-12 lg:px-20 py-24 text-center bg-black/90 border-y border-white/10"
    >
      <div className="fade-up" style={{ "--d": "0ms" }}>
        <h2
          className="text-[clamp(2.5rem,6vw,5rem)] font-semibold tracking-tight text-white"
          style={{ letterSpacing: "-0.02em" }}
        >
          360° SERVICES
        </h2>
        <p className="mt-4 text-lg md:text-xl text-white/80 max-w-3xl mx-auto">
          We deliver <span className="text-[#A78BFA] font-semibold">360° strategic, digital and field solutions</span> —
          from insights to execution, ensuring every campaign move creates value and impact.
        </p>

        
      </div>
    </section>
  );
}


/* ---------------- CTA ---------------- */
function BigCTA() {
  return (
    <section id="contact" className="w-full px-6 md:px-12 lg:px-20 py-16 text-center">
      <div className="rounded-3xl border border-white/10 p-8 bg-gradient-to-br from-white/5 to-transparent">
        <h3 className="text-3xl font-semibold">Ready for your next campaign?</h3>
        <p className="mt-3 text-white/75 max-w-2xl mx-auto">
          Let’s build a win path with credible data, sharp narratives and disciplined ground ops.
        </p>
        <div className="mt-6 flex justify-center gap-3 flex-wrap">
          <a
            className="inline-flex items-center gap-2 rounded-2xl px-5 py-3 bg-[#8B5CF6] text-white font-medium hover:opacity-90"
            href="#getintouch"
          >
            Schedule a 30-min consult
          </a>

          
        </div>
      </div>
    </section>
  );
}


/* ---------------- PHILOSOPHY SECTION ---------------- */
function PhilosophySection() {
  return (
    <section
      id="philosophy"
      className="w-full px-6 md:px-12 lg:px-20 py-20 border-t border-white/10 bg-gradient-to-b from-[#0B0A17]/95 to-black/90"
    >
      <div className="grid lg:grid-cols-2 gap-10 items-center">
        {/* LEFT: Team photo */}
        <div className="relative h-[240px] sm:h-[320px] md:h-[420px] rounded-3xl overflow-hidden border border-white/10 shadow-lg">
          <img
            src={teamImg}
            alt="Team, Kurukshetra Analytics"
            style={{
    width: "100%",
    height: "auto",
    imageRendering: "crisp-edges", // or 'high-quality'
  }}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent" />
          <div className="absolute bottom-4 left-4 text-sm text-white/80">
            <p className="font-semibold text-white">Team</p>
            <p className="text-white/60 text-xs">Kurukshetra Analytics</p>
          </div>
        </div>

        {/* RIGHT: Text content */}
        <div className="fade-up space-y-5" style={{ "--d": "0ms" }}>
          <h2 className="text-3xl md:text-4xl font-semibold text-white mb-4">
            Our Philosophy
          </h2>

          <p className="text-white/85 text-base leading-relaxed">
            We believe politics is not just about winning elections — it’s about
            deepening democracy and strengthening civic engagement. Our work is
            rooted in listening to people at the grassroots, understanding their
            issues, and ensuring those voices shape both manifestos and
            governance priorities.
          </p>

          <p className="text-white/85 text-base leading-relaxed">
            We see ourselves as partners in building a more accountable and
            people-centered democracy. By aligning with leaders who share this
            vision, we help translate community needs into actionable policies,
            ensuring that every campaign is not just about votes, but about
            voices.
          </p>

          <p className="text-white/85 text-base leading-relaxed">
            Our shared goal with candidates is clear: to make democracy
            stronger, civic participation wider, and leadership more responsive.
            When the right leaders are empowered, society as a whole moves
            forward.
          </p>

          <div className="pt-4">
            <a
              href="/team"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-2xl border border-white/20 text-white/90 hover:border-white/40 transition"
            >
              Meet the Team
              <ChevronRight className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}



/* ---------------- CONTACT US (New Business + Careers only) ---------------- */
function ContactSection() {
  const intents = [
    { key: "newbiz", title: "New Business", icon: Mail, desc: "Talk strategy, data, and ground ops." },
    { key: "careers", title: "Careers", icon: Briefcase, desc: "Explore open roles and join the team." },
  ];

  const [sent, setSent] = useState(false);

async function handleSubmit(e) {
  e.preventDefault();

  const form = e.currentTarget;
  const data = new FormData(form);
  data.append("form-name", "contact"); // important for Netlify

  try {
    await fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(data).toString(),
    });

    setSent(true);
    form.reset();
  } catch (err) {
    alert("Something went wrong. Please try again.");
  }
}


  return (
    <section id="getintouch" className="w-full px-6 md:px-12 lg:px-20 py-16">
      {/* Header */}
      <div className="max-w-3xl">
        <h2 className="text-3xl font-semibold fade-up" style={{ "--d": "0ms" }}>
          Get in touch
        </h2>
        <p className="text-white/80 mt-3 fade-up" style={{ "--d": "120ms" }}>
          Ready to make an impact? Share your details and our team will be in touch shortly.
        </p>
      </div>

      {/* Intent tiles */}
      

      {/* Contact form + HQ info */}
      <div id="contact-form" className="grid lg:grid-cols-2 gap-8 mt-10">
        {/* Left: form */}
        <form
  name="contact"
  method="POST"
  data-netlify="true"
  netlify-honeypot="bot-field"
  onSubmit={handleSubmit}
  className="fade-up rounded-3xl border border-white/10 p-6 bg-black/30 backdrop-blur-sm"
  style={{ "--d": "0ms" }}
>
  {/* REQUIRED hidden inputs so Netlify recognizes this form */}
  <input type="hidden" name="form-name" value="contact" />
  {/* Honeypot (spam filter) */}
  <p className="hidden">
    <label>
      Don’t fill this out if you’re human: <input name="bot-field" />
    </label>
  </p>

  <div className="grid md:grid-cols-2 gap-4">
    <div>
      <label className="block text-sm text-white/70 mb-1">First name</label>
      <input
        required
        name="firstName"
        className="w-full rounded-xl bg-white/5 border border-white/15 px-3 py-2 focus:ring-2 focus:ring-[#8B5CF6]/60"
      />
    </div>
    <div>
      <label className="block text-sm text-white/70 mb-1">Last name</label>
      <input
        required
        name="lastName"
        className="w-full rounded-xl bg-white/5 border border-white/15 px-3 py-2 focus:ring-2 focus:ring-[#8B5CF6]/60"
      />
    </div>
    <div className="md:col-span-2">
      <label className="block text-sm text-white/70 mb-1">Email</label>
      <input
        required
        type="email"
        name="email"
        className="w-full rounded-xl bg-white/5 border border-white/15 px-3 py-2 focus:ring-2 focus:ring-[#8B5CF6]/60"
      />
    </div>
    <div className="md:col-span-2">
      <label className="block text-sm text-white/70 mb-1">Message</label>
      <textarea
        required
        name="message"
        rows={5}
        className="w-full rounded-xl bg-white/5 border border-white/15 px-3 py-2 focus:ring-2 focus:ring-[#8B5CF6]/60"
        placeholder="Share a few details about your inquiry..."
      />
    </div>
  </div>

  <div className="mt-4 flex items-start gap-2">
    <input id="consent" name="consent" type="checkbox" required className="mt-1" />
    <label htmlFor="consent" className="text-sm text-white/70">
          I agree to Kurukshetra Analytics collecting and processing my personal data to allow me to receive information on Kurukshetra Analytics services.
    </label>
  </div>

  <button
    type="submit"
    className="mt-6 inline-flex items-center gap-2 rounded-2xl px-5 py-3 bg-[#8B5CF6] text-white font-medium hover:opacity-90"
  >
    Send message
  </button>

  {/* Thank-you message */}
  {sent && (
    <p className="mt-4 text-sm text-green-400">
      ✅ Thanks! We’ll be in touch soon.
    </p>
  )}
</form>


        {/* Right: photo fills the space */}
<div
  className="fade-up relative rounded-3xl overflow-hidden border border-white/10 bg-black/30 h-full"
  style={{ "--d": "120ms" }}
>
  {/* Image */}
  <img
    src={contactSide}
    alt="Kurukshetra Analytics — field operations and strategy at work"
    className="absolute inset-0 h-full w-full object-cover"
  />

  {/* Soft overlay so text on the left remains the focal point */}
  <div className="absolute inset-0 bg-gradient-to-tr from-[#0B0A17]/50 via-transparent to-transparent" />

 
</div>

        
      </div>
    </section>
  );
}


/* ---------------- FOOTER ---------------- */
function Footer() {
  return (
    <footer className="border-t border-white/10 py-10 text-sm text-white/75 text-center">
      <p className="font-semibold text-white text-lg mb-2">Kurukshetra Analytics</p>
      <p>Bengaluru • Active in Karnataka, Telangana & Andhra Pradesh</p>
      <p className="mt-4 text-xs text-white/55">
        © {new Date().getFullYear()} Kurukshetra Analytics. All rights reserved.
      </p>
    </footer>
  );
}

